exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auditDesc[data-v-a01855a2] {\n  border: 0.005208rem solid #ececec;\n  height: 30vh;\n  text-align: center;\n}\n.auditDesc .title[data-v-a01855a2] {\n  font-size: 0.104167rem;\n  padding: 0.052083rem 0;\n  font-weight: bold;\n}\n.auditDesc .titleDesc[data-v-a01855a2] {\n  font-size: 0.083333rem;\n  padding: 0.026042rem 0;\n}\n.printBtn[data-v-a01855a2] {\n  text-align: right;\n}\n.tableMode td[data-v-a01855a2] {\n  padding: 0.010417rem;\n}", ""]);

// exports
